module.exports = __webpack_public_path__ + "media/images/logo2-82905982ddaf11b528b4935a99680d46.png";